export default {
  mainContainer: {
    height: '100%'
  }
};
